import { Box, Typography } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const StyledItemContainer = styled(Box)<{ isDevice: boolean}>`
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: space-between; 
`

interface NotificationItemProps {
  name: string | ReactNode
  toggleItem: ReactNode
}

export const NotificationItem: FC<NotificationItemProps> = props => {
  const { name, toggleItem } = props
  const { isDevice } = useScreenSizes()
  return (
    <StyledItemContainer isDevice={isDevice}>
      <Typography variant="subtitle1">{name}</Typography>
      {toggleItem}
    </StyledItemContainer>
  ) 
}
